import React from 'react';
import { Layout, RoutesMenu, GetInfo } from '../../components';
import '../../assets/styles/containers/Routes.sass';

const Stage4 = () => {
  return (
    <div className="Stage4">
      <Layout bannerId={75}>
        <RoutesMenu/>
        <div className="container">
          <GetInfo id={142}/>
        </div>
      </Layout>
    </div>
  );
};

export default Stage4;
